import { useCallback } from 'react';

export const useSessionStorage = () => {
  const getItem = useCallback((key: string): string | null => {
    try {
      return window.sessionStorage.getItem(key);
    } catch {
      return null;
    }
  }, []);

  const setItem = useCallback((key: string, value: string): void => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch {}
  }, []);

  const removeItem = useCallback((key: string): void => {
    try {
      window.sessionStorage.removeItem(key);
    } catch {}
  }, []);

  return { getItem, setItem, removeItem };
};
